"use strict";

exports.__esModule = true;
exports.ReportListItemThumbnailWrapper = exports.ReportListItemThumbnail = exports.ReportListItemLabel = exports.ReportListItemHeading = exports.ReportListItem = exports.ReportListContainer = exports.ReportListAccordianGridViewContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _Theme = require("../../../Theme");
var _ReportThumbnail = require("../../ReportThumbnail");
var _ListView = require("../../../Core/ListView");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ReportListItem = exports.ReportListItem = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "styledComponents__ReportListItem",
  componentId: "sc-1l6h3xt-0"
})(["color:", ";background:", ";padding:0.5rem;box-shadow:0 0 5px ", ";border-radius:", ";transition:box-shadow 0.3s;transition:background 0.5s;text-align:center;&:hover{text-decoration:none;color:", ";background:", ";box-shadow:0 0 5px ", ";}"], (0, _Theme.selectable)("ThumbnailListItemColor"), (0, _Theme.selectable)("ThumbnailListItemBackground"), (0, _Theme.selectable)("ThumbnailListItemShadow"), (0, _Theme.selectable)("ThumbnailListItemBorderRadius"), (0, _Theme.val)("SelectedThumbnailListItemColor"), (0, _Theme.val)("SelectedThumbnailListItemBackground"), (0, _Theme.val)("SelectedThumbnailListItemShadow"));
var ReportListItemThumbnail = exports.ReportListItemThumbnail = (0, _styledComponents["default"])(_ReportThumbnail.ReportThumbnail).withConfig({
  displayName: "styledComponents__ReportListItemThumbnail",
  componentId: "sc-1l6h3xt-1"
})(["height:", "px;width:", "px;"], function (props) {
  return props.height || "80";
}, function (props) {
  return props.width || "80";
});
var ReportListItemThumbnailWrapper = exports.ReportListItemThumbnailWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styledComponents__ReportListItemThumbnailWrapper",
  componentId: "sc-1l6h3xt-2"
})(["height:", "px;width:", "px;"], function (props) {
  return props.height || "80";
}, function (props) {
  return props.width || "80";
});
var ReportListItemLabel = exports.ReportListItemLabel = _styledComponents["default"].div.withConfig({
  displayName: "styledComponents__ReportListItemLabel",
  componentId: "sc-1l6h3xt-3"
})(["color:", ";line-height:1rem;height:32px;font-size:0.875rem;overflow:hidden;word-wrap:normal;max-width:100%;text-align:center;margin:0.25rem;"], (0, _Theme.selectable)("ThumbnailListItemColor"));
var ReportListItemHeading = exports.ReportListItemHeading = (0, _styledComponents["default"])(_ListView.ListItemHeading).withConfig({
  displayName: "styledComponents__ReportListItemHeading",
  componentId: "sc-1l6h3xt-4"
})(["font-size:0.875rem;"]);
var ReportListContainer = exports.ReportListContainer = _styledComponents["default"].div.withConfig({
  displayName: "styledComponents__ReportListContainer",
  componentId: "sc-1l6h3xt-5"
})(["display:flex;flex:1;flex-direction:column;height:100%;padding:1.25rem;"]);
var ReportListAccordianGridViewContainer = exports.ReportListAccordianGridViewContainer = _styledComponents["default"].div.withConfig({
  displayName: "styledComponents__ReportListAccordianGridViewContainer",
  componentId: "sc-1l6h3xt-6"
})(["display:grid;padding:1.25rem;grid-gap:1.25rem;grid-template-columns:repeat(auto-fill,120px);grid-template-rows:repeat(auto-fill,120px);"]);